import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const SectionHeader = styled.header`
  max-width: 552px;
  width: 100%;
  margin: 0 auto 58px;
  text-align: center;
  @media only screen and (max-width: 991px) {
    margin-bottom: 50px;
  }
  h5,
  p.eyebrow {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 12px;
    letter-spacing: 1.5px;
    color: ${'#46679f'};
    text-transform: uppercase;
    @media only screen and (max-width: 991px) {
      font-size: 13px;
      margin-bottom: 10px;
    }
  }
  h2 {
    font-size: 30px;
    line-height: 36px;
    font-weight: 700;
    color: ${themeGet('colors.headingColor', '#0F2137')};
    margin: 0;
    letter-spacing: -1px;
    @media only screen and (max-width: 1366px) {
      font-size: 28px;
      letter-spacing: -0.7px;
    }
    @media only screen and (max-width: 991px) {
      font-size: 26px;
      line-height: 38px;
      letter-spacing: -0.5px;
    }
  }
`;

export const QuoteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 990px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const QuoteCard = styled.figure`
  margin: 0;
  background: #fff;
  border: 1px solid #e2eaf3;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 8px 30px rgba(15, 33, 55, 0.06);
  display: flex;
  flex-direction: column;

  blockquote {
    margin: 0 0 20px;
    font-size: 15px;
    color: #343d48cc;
    line-height: 1.75;
    flex-grow: 1;
  }

  footer {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .name {
      font-size: 15px;
      font-weight: 700;
      color: #0f2137;
    }

    .role {
      font-size: 13px;
      color: #5d646d;
    }

    a {
      margin-top: 6px;
      font-size: 13px;
      color: ${'#46679f'};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .source {
      margin-top: 6px;
      font-size: 13px;
      color: #5d646d;
    }
  }
`;

export default SectionHeader;
